module["exports"] = ["S.L.", "e Hijos", "S.A.", "Hermanos"];